export const componentSidebarTheme = {
  bg: 'palette.surface.3',
  openButton: 'palette.neutral.60',
  propertyItem: {
    borderColor: 'palette.surface.5',
    borderWidth: '1px',
    fontWeight: 700,
    showButton: 'palette.secondary.80',
    text: 'palette.neutral.90',
  },
  propertyPath: 'palette.neutral.90',
};
